export interface TypeAHeadOption {
    label: string;
    value: string;
};
export interface TypeAHeadSelectEvent extends TypeAHeadOption {
    index: number
}

export enum SearchListCategory {
    ALL = "all",
}

export enum ItemType {
    VESSEL = "vessel",
}
